import {
    FETCH_ALL_CONFIGURATION_DATA,
    FETCH_CONFIGURATION_DATA,
    SET_ACTIVE_CONFIGURATION,
    SET_CONFIGURATION_DATA,
    SET_IS_FROM_RULES_GRID,
    SET_IGNORE_DEFAULT_CONFIGURATION,
    SET_IS_CLEAR_APPLIED_CONFIGURATION,
    SET_REDIRECTION,
    SHOW_CONFIGURATION_ICON,
    SHOW_SAVE_CONFIGURATION_MODAL,
    SHOW_SAVE_AS_CONFIGURATION_MODAL,
    UPDATE_CONFIGURATION_DATA
} from '../actions/actionTypes';

import template from 'url-template';
import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';

import queryString from 'query-string';

import { setBobLoading } from './bobActions';
import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { get, isEmpty, orderBy } from 'lodash';

const SaveConfigurationUrl = template.parse('/users/{userId}/user-views');
const GetConfigurationUrl = template.parse('/users/{userId}/user-views{?viewKey,entityId}');
const UpdateOrDeleteViewUrl = template.parse('/user-views/{userViewId}');

export const setConfigurationData = payload => ({
    type: SET_CONFIGURATION_DATA,
    payload
});

export const saveConfiguration = ( userId, body, disableSnackbar) => async (dispatch) => {
    const header = await awsHeader();

    dispatch(setBobLoading('SaveViewAndConfiguration'));

    try {
        const response = await k2aBaseApi.post(
            SaveConfigurationUrl.expand({
                userId
            }),
            body,
            header
        );

        const id = get(response, 'data.id', '');
        
        // set newConfiguration field as empty in redux
        dispatch(setConfigurationData({}));
        dispatch(setShowSaveConfigurationModal(false));
        if (!disableSnackbar) dispatch(enqueueSnackbar('View & Configuration Saved Successfully.', 'success'));

        return id;
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('SaveViewAndConfiguration'));
    }
};

export const updateConfiguration = ( userViewId, body, disableSnackbar) => async (dispatch, getState) => {
    const header = await awsHeader();
    
    // sharedEmailsString field is on;y for Display purpose
    if ('sharedEmailsString' in body) {
        delete body.sharedEmailsString;
    }

    dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));

    try {
        const response = await k2aBaseApi.put(
            UpdateOrDeleteViewUrl.expand({
                userViewId
            }),
            body,
            header
        );
        
        const payload = get(response, 'data', []);
        let allConfigurationsList = getState().configurationData.allConfigurations;
        const configIndex = allConfigurationsList.findIndex(c => c.id === payload.id);

        if (configIndex !== -1) {
            allConfigurationsList[configIndex] = payload;
        }

        dispatch({
            type:    FETCH_ALL_CONFIGURATION_DATA,
            payload: allConfigurationsList
        });

        dispatch(setShowSaveConfigurationModal(false));
        dispatch(setUpdateConfigurationData(false));
        if (!disableSnackbar) dispatch(enqueueSnackbar('View & Configuration Updated Successfully.', 'success'));
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));
    }
};

export const deleteConfiguration = ( userViewId ) => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));

    try {
        await k2aBaseApi.delete(
            UpdateOrDeleteViewUrl.expand({
                userViewId
            }),
            header
        );
        
        // update configurations list after delete
        let allConfigurations = getState().configurationData.allConfigurations;
        let activeConfiguration = getState().configurationData.activeConfiguration;
        
        if (activeConfiguration.id === userViewId) {
            dispatch(setActiveConfiguration({}));
        }
        if (!isEmpty(allConfigurations)) {
            const allConfigurationsList = allConfigurations.filter(item => item.id !== userViewId);

            dispatch({
                type:    FETCH_ALL_CONFIGURATION_DATA,
                payload: allConfigurationsList
            });
        }

        dispatch(setShowSaveConfigurationModal(false));
        dispatch(enqueueSnackbar('View & Configuration Deleted Successfully.', 'success'));
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));
    }
};

export const bulkDeleteConfigurations = configurationIds => async (dispatch, getState) => {
    const header = await awsHeader();
    const errorList = [];

    dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));

    try {
        let promises = [];
        configurationIds.forEach(item => {
            promises.push(k2aBaseApi.delete(UpdateOrDeleteViewUrl.expand({userViewId: item}), header));
        });

        await Promise.all(promises.map(p => p.catch(err => {
            errorList.push({error: err});
        })));

        if (errorList.length > 0) {
            if (errorList.length === 1) {
                dispatch(handleNetworkError(errorList[0].error));
                return;
            }
            else {
                throw new Error('Multiple Errors Occurred');
            }
        }
        // update configurations list after delete
        let allConfigurations = getState().configurationData.allConfigurations;
        
        if (!isEmpty(allConfigurations)) {
            const allConfigurationsList = allConfigurations.filter(item => !configurationIds.includes(item.id));

            dispatch({
                type:    FETCH_ALL_CONFIGURATION_DATA,
                payload: allConfigurationsList
            });
        }

        dispatch(setShowSaveConfigurationModal(false));
        dispatch(enqueueSnackbar('View & Configurations Deleted Successfully.', 'success'));
        return true;
    }
    catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
    finally {
        dispatch(setBobLoading('UpdateOrDeleteViewAndConfiguration'));
    }
};

export const fetchConfigurations = ( userId, entityId, viewKey, onMount = false) => async (dispatch, getState) => {
    const header = await awsHeader();

    const queryValues = queryString.parse(window.location.search);
    let viewId = queryValues && queryValues.viewId ? queryValues.viewId : null;

    dispatch(setBobLoading('fetchConfigurations'));

    try {
        const response = await k2aBaseApi.get(
            GetConfigurationUrl.expand({
                userId,
                entityId,
                viewKey
            }),
            header
        );
        
        let data = get(response, 'data', []);
        
        // fetch Equipment - Sensors - Configuration tab views
        if (viewKey === 'BOB|EquipmentDashboard|Sensor') {
            const tempResponse = await k2aBaseApi.get(
                GetConfigurationUrl.expand({
                    userId,
                    entityId,
                    viewKey: 'BOB|EquipmentDashboard|Configuration'
                }),
                header
            );
            
            let tempData = get(tempResponse, 'data', []);
            
            // merging Sensor & Configuration tab view
            data = [
                ...data,
                ...tempData
            ];
        // fetch System - Sensors - Configuration tab views
        } else if (viewKey === 'BOB|SystemDashboard|Sensor') {
            const tempResponse = await k2aBaseApi.get(
                GetConfigurationUrl.expand({
                    userId,
                    entityId,
                    viewKey: 'BOB|SystemDashboard|Configuration'
                }),
                header
            );
            
            let tempData = get(tempResponse, 'data', []);
            
            // merging Sensor & Configuration tab view
            data = [
                ...data,
                ...tempData
            ];
        }

        data.forEach(configuration => {
            if (configuration.viewData) {
                configuration.viewData = JSON.parse(configuration.viewData);
                // This is for Default View Column in ConfigurationsTable
                configuration.sharedEmailsString = configuration.sharedEmails.join(', ');
            }
        });

        // sorting alphabetically
        data = orderBy(data, ['name'], ['asc']);

        dispatch({
            type:    FETCH_CONFIGURATION_DATA,
            payload: data
        });

        const isFromRulesGrid = getState().configurationData.isFromRulesGrid;
        const ignoreDefaultConfiguration = getState().configurationData.ignoreDefaultConfiguration;

        if (isFromRulesGrid) {
            dispatch(setIsFromRulesGrid(false));
            dispatch(setActiveConfiguration({}));
        } else if (!isEmpty(data) && onMount && !viewId && !ignoreDefaultConfiguration) {
            // check entity has default view or not
            let defaultView = data.filter(view => view.isDefault === true && view.viewKey === viewKey);
            dispatch(setActiveConfiguration(defaultView[0] || {}));
        } else if (viewId && onMount && !ignoreDefaultConfiguration) {
            // check url has viewId or not
            let activeView = data.filter(view => view.id === viewId);
            dispatch(setActiveConfiguration(activeView[0] || {}));
        }

        if (ignoreDefaultConfiguration) {
            dispatch(setActiveConfiguration({}));
            dispatch(setIgnoreDefaultConfiguration(false));
        }
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('fetchConfigurations'));
    }
};

export const fetchAllConfigurations = ( userId) => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('fetchAllConfigurations'));

    try {
        const response = await k2aBaseApi.get(
            GetConfigurationUrl.expand({
                userId
            }),
            header
        );
        
        let data = get(response, 'data', []);
        const userEmail = getState().currentUser.email;

        data.forEach(configuration => {
            if (configuration.viewData) {
                configuration.viewData = JSON.parse(configuration.viewData);
                // hide the current user email address
                configuration.sharedEmails = configuration.sharedEmails.filter(item => item !== userEmail);
                // This is for Default View Column in ConfigurationsTable
                configuration.sharedEmailsString = configuration.sharedEmails.join(', ');
            }
        });

        // sorting alphabetically
        data = orderBy(data, ['name'], ['asc']);

        dispatch({
            type:    FETCH_ALL_CONFIGURATION_DATA,
            payload: data
        });

    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('fetchAllConfigurations'));
    }
};

export const updateAllConfigurations = (userViewId, body) => async (dispatch, getState) => {
    const configurations = getState().configurationData.allConfigurations;
    const updatedConfigurations = [...configurations];

    const configurationIndex = configurations.findIndex(configuration => configuration.id === userViewId);

    if (configurationIndex >= 0) {
        updatedConfigurations[configurationIndex] = body;
        updatedConfigurations[configurationIndex].viewData = JSON.parse(updatedConfigurations[configurationIndex].viewData);

        dispatch({
            type:    FETCH_ALL_CONFIGURATION_DATA,
            payload: updatedConfigurations
        });
    }
};

export const updateCoreConfigurations = (userViewId, body) => async (dispatch, getState) => {
    const configurations = getState().configurationData.allConfigurations;
    const updatedConfigurations = [...configurations];

    const configurationIndex = configurations.findIndex(configuration => configuration.id === userViewId);

    if (configurationIndex >= 0) {
        updatedConfigurations[configurationIndex] = body;

        if (typeof updatedConfigurations[configurationIndex].viewData === 'string') {
            updatedConfigurations[configurationIndex].viewData = JSON.parse(updatedConfigurations[configurationIndex].viewData);
        }

        dispatch({
            type:    FETCH_ALL_CONFIGURATION_DATA,
            payload: updatedConfigurations
        });
    } else {
        updatedConfigurations.push(body);

        dispatch({
            type:    FETCH_ALL_CONFIGURATION_DATA,
            payload: updatedConfigurations
        });
    }
};

export const setActiveConfiguration = configuration => async (dispatch) => {
    dispatch({
        type:    SET_ACTIVE_CONFIGURATION,
        payload: configuration
    });
};

export const setActiveReportConfiguration = configurationId => async (dispatch, getState) => {
    let configurations = getState().configurationData.configurations;
    let view = configurations.filter(config => config.id === configurationId);

    if (!isEmpty(view)) {
        dispatch({
            type:    SET_ACTIVE_CONFIGURATION,
            payload: view[0]
        });
    }
};

export const setShowSaveConfigurationModal =  isShow => async (dispatch) => {
    dispatch({
        type:    SHOW_SAVE_CONFIGURATION_MODAL,
        payload: isShow
    });
};

export const setShowConfigurationIcon =  isShow => async (dispatch) => {
    dispatch({
        type:    SHOW_CONFIGURATION_ICON,
        payload: isShow
    });
};

export const setShowSaveAsConfigurationModal =  isShow => async (dispatch) => {
    dispatch({
        type:    SHOW_SAVE_AS_CONFIGURATION_MODAL,
        payload: isShow
    });
};

export const setUpdateConfigurationData =  isUpdate => async (dispatch) => {
    dispatch({
        type:    UPDATE_CONFIGURATION_DATA,
        payload: isUpdate
    });
};

export const setIsFromRulesGrid =  isFromRulesGrid => async (dispatch) => {
    dispatch({
        type:    SET_IS_FROM_RULES_GRID,
        payload: isFromRulesGrid
    });
};

export const setIsClearAppliedConfiguration =  isClear => async (dispatch) => {
    dispatch({
        type:    SET_IS_CLEAR_APPLIED_CONFIGURATION,
        payload: isClear
    });
};

export const setRedirection =  tabView => async (dispatch) => {
    dispatch({
        type:    SET_REDIRECTION,
        payload: tabView
    });
};

export const setIgnoreDefaultConfiguration = ignore => async (dispatch) => {
    dispatch({
        type:    SET_IGNORE_DEFAULT_CONFIGURATION,
        payload: ignore
    });
};
